import dateFns from 'date-fns';
import { convertStringDigitToDate } from './date-helper';
import { fiflboxApi } from '@/utils/api';

const regEmail = /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

function isEmail(email) {
  return regEmail.test(email);
}

function validate8DigitDate(value) {
  const numberCheckReg = /\d{8}/;
  const isValidDigitDate = numberCheckReg.test(value);

  if (!isValidDigitDate) {
    return false;
  }

  return dateFns.isValid(convertStringDigitToDate(value));
}

function validateInCalender(value) {
  const year = Number(value.slice(0, 4));
  const month = Number(value.slice(4, 6));
  const day = Number(value.slice(6, 8));

  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}

export function validateBirthday(rule, value, callback) {
  if (value.length !== 8) {
    return callback('생년월일 8자리를 입력해주세요.');
  }

  if (!validate8DigitDate(value)) {
    return callback('생년월일을 정확하게 입력해주세요.');
  }

  if (!validateInCalender(value)) {
    return callback('생년월일을 정확하게 입력해주세요.');
  }

  callback();
}

export async function validateEmailOnSignup(rule, value, callback) {
  if (!value) {
    return callback(new Error('이메일을 입력해주세요.'));
  }

  if (!isEmail(value)) {
    return callback(new Error('정확한 이메일을 입력해주세요.'));
  }

  try {
    const { data } = await fiflboxApi.v1.postCheckEmail({
      email: value
    });

    if (data.exist) {
      return callback(new Error('이미 사용중인 이메일입니다.'));
    }
  } catch (err) {
    return callback();
  }
}

export async function validateEmailOnInstructor(rule, value, callback) {
  if (!value) {
    return callback(new Error('이메일을 입력해주세요.'));
  }

  if (!isEmail(value)) {
    return callback(new Error('정확한 이메일을 입력해주세요.'));
  }

  try {
    const { data } = await fiflboxApi.v1.postCheckInstructorEmail({
      email: value
    });

    if (data.exist) {
      callback(new Error('이미 사용중인 이메일입니다.'));
    }
  } catch (err) {
    callback();
  }
}

export async function validateCenterTitle(rule, value, callback) {
  if (!value) {
    return callback(new Error('센터명을 입력해주세요.'));
  }

  if (/[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9\s)]/gi.test(value)) {
    return callback(new Error('특수문자 입력이 불가합니다.'));
  }

  try {
    const { data } = await fiflboxApi.v1.postCheckCenterName({
      name: value
    });

    if (data.exist) {
      callback(new Error('이미 가입된 센터입니다. '));
    }
  } catch (err) {
    callback();
  }
}

export function validateEmailOnLogin(rule, value, callback) {
  if (!value) {
    return callback(new Error('이메일을 입력해주세요.'));
  }

  if (!isEmail(value)) {
    return callback(new Error('정확한 이메일을 입력해주세요.'));
  }

  callback();
}

export function validatePassword(rule, value, callback) {
  if (!value) {
    return callback(new Error('비밀번호를 입력해주세요.'));
  }

  if (!/^[a-zA-Z0-9!@#$%^&*()-_+=~₩`]{8,}$/.test(value)) {
    return callback(new Error('8자리 이상의 영문/숫자를 조합해주세요.'));
  }

  if (/^[!@#$%^&*()-_+=~₩`]{1,}$/.test(value)) {
    return callback(new Error('8자리 이상의 영문/숫자를 조합해주세요.'));
  }

  if (/^[0-9]{1,}$/.test(value)) {
    return callback(new Error('8자리 이상의 영문/숫자를 조합해주세요.'));
  }

  if (/^[a-zA-Z]{1,}$/.test(value)) {
    return callback(new Error('8자리 이상의 영문/숫자를 조합해주세요.'));
  }

  callback();
}

export function validateName(rule, value, callback) {
  if (!value) {
    return callback(new Error('성함을 입력해주세요.'));
  }

  if (/[0-9.;\-]/.test(value) || /[^(가-힣a-zA-Z0-9\s)]/gi.test(value)) {
    return callback(new Error('성함을 정확하게 입력해주세요.'));
  }

  callback();
}

export function validatePhoneNum(rule, value, callback) {
  if (!value) {
    return callback(new Error('휴대전화번호를 입력해주세요.'));
  }

  if (value.includes('-')) {
    return callback(new Error('-을 제외하고 입력해주세요.'));
  }

  if (!/^((01[1|6|7|8|9])[1-9]+[0-9]{6,7})|(010[1-9][0-9]{7})$/.test(value)) {
    return callback(new Error('정확한 휴대전화번호를 입력해주세요.'));
  }

  callback();
}

export function validateIdNum(rule, value, callback) {
  if (!value) {
    return callback(new Error('주민번호를 입력해주세요.'));
  }

  if (value.slice(6, 7) <= 0 || value.slice(6, 7) > 4) {
    return callback(new Error('주민번호를 정확하게 입력해주세요.'));
  }

  if (!/^[0-9]{7}$/.test(value)) {
    return callback(new Error('주민번호를 정확하게 입력해주세요.'));
  }

  callback();
}

export function validateArray(rule, value, callback) {
  if (!Array.isArray(value)) {
    return callback(new Error(' '));
  }

  if (value.length === 0) {
    return callback(new Error(' '));
  }

  callback();
}

export function validateInflow(rule, value, callback) {
  if (!value) {
    return callback(new Error('유입 경로를 입력해주세요.'));
  }

  if (/[^(가-힣a-zA-Z\s)]/gi.test(value)) {
    return callback(new Error('숫자 또는 특수문자를 제외하고 입력해 주세요.'));
  }

  // if (/[.;\-]/.test(value) || /[^(가-힣a-zA-Z\s)]/gi.test(value)) {
  //   return callback(new Error('유입 경로를 정확히 입력해주세요.'));
  // }

  callback();
}

export function validateUrl(rule, value, callback) {
  const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

  if (value && pattern.test(value) === false) {
    return callback(
      new Error('http:// 또는 https://로 시작하는 유효한 URL을 입력하세요.')
    );
  }

  callback();
}
